(() => {
  const details = document.querySelector('.product-details');
  if (!details) return;
  const quantities = '.quantity-selector-wrapper input[type="number"]';
  const prices = new Map();
  const currency = window.Shopify?.currency?.active || 'EUR';
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency });
  const productsUrl = document.getElementById('lc-accommodation-dialog')?.dataset.productsUrl || '/products/';
  let frame;

  function isPension(input) {
    return /pension/i.test(input?.getAttribute('data-field-name') || input?.name || '');
  }

  function product(handle) {
    if (!prices.has(handle)) {
      prices.set(handle, fetch(`${productsUrl}${encodeURIComponent(handle)}.js`)
        .then((response) => {
          if (!response.ok) throw new Error('Pension price unavailable');
          return response.json();
        })
        .catch((error) => { prices.delete(handle); throw error; }));
    }
    return prices.get(handle);
  }

  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(update);
  }

  async function update() {
    details.querySelectorAll('.gpo-total-text').forEach((summary) => {
      const walker = document.createTreeWalker(summary, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const text = node.nodeValue
          .replace('Cette sélection va ajouter', "Cette sélection d'options va ajouter")
          .replace("Cette sélection d'option va ajouter", "Cette sélection d'options va ajouter")
          .replace('au prix du package', 'au tarif de la mini-cure');
        if (text !== node.nodeValue) node.nodeValue = text;
      }
    });
    const quantity = Number(details.querySelector(quantities)?.value || 1);
    const mainPrices = document.querySelectorAll('.product-details product-price .price, .mc-sticky-cta__amount');
    details.querySelectorAll('product-price .compare-at-price').forEach((node) => {
      node.hidden = quantity > 2;
    });
    if (quantity > 2) {
      mainPrices.forEach((node) => {
        if (node.textContent !== 'A deviser ensemble') node.textContent = 'A deviser ensemble';
      });
      return;
    }
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 2) return;
    const mainHandle = document.getElementById('lc-booking-pricing')?.dataset.productHandle;
    if (mainHandle) {
      try {
        const data = await product(mainHandle);
        if (quantity !== Number(details.querySelector(quantities)?.value || 1)) return;
        const variantId = details.querySelector('form input[name="id"]')?.value;
        const variant = data.variants.find((item) => String(item.id) === variantId);
        if (variant) {
          const total = formatter.format(variant.price * quantity / 100);
          document.querySelectorAll('.product-details product-price .price, .mc-sticky-cta__amount').forEach((node) => {
            if (node.textContent !== total) node.textContent = total;
          });
          if (variant.compare_at_price > variant.price) {
            const compareTotal = formatter.format(variant.compare_at_price * quantity / 100);
            details.querySelectorAll('product-price .compare-at-price').forEach((node) => {
              if (node.textContent !== compareTotal) node.textContent = compareTotal;
            });
          }
        }
      } catch {
        // Keep the theme's original price if the product cannot be loaded.
      }
    }
    const inputs = [...details.querySelectorAll('.gpo-swatches.buttons input[type="radio"]')].filter(isPension);
    await Promise.all(inputs.map(async (input) => {
      const handle = input.getAttribute('gpo-data-product-handle');
      if (!handle) return;
      try {
        const data = await product(handle);
        if (!input.isConnected || quantity !== Number(details.querySelector(quantities)?.value || 1)) return;
        const variant = data.variants.find((item) => String(item.id) === input.getAttribute('gpo-data-variant-id'));
        if (!variant) return;
        const card = input.closest('.gpo-ov-item');
        const amount = `(+ ${formatter.format(variant.price * quantity / 100)})`;
        card.querySelectorAll('.addOn').forEach((node) => {
          if (node.textContent !== amount) node.textContent = amount;
        });
        let note = card.querySelector('.mc-pension-participants');
        if (!note) {
          note = document.createElement('small');
          note.className = 'mc-pension-participants';
          card.querySelector('label .gpo-ov-title')?.append(note);
        }
        const text = `Pour ${quantity} ${quantity === 1 ? 'adulte' : 'adultes'}`;
        if (note.textContent !== text) note.textContent = text;
      } catch {
        // Keep Globo's original price if the product cannot be loaded.
      }
    }));
    const selected = [...details.querySelectorAll('.gpo-app input:checked[gpo-data-product-handle]')];
    if (!selected.some(isPension)) return;
    try {
      const amounts = await Promise.all(selected.map(async (input) => {
        const data = await product(input.getAttribute('gpo-data-product-handle'));
        const variant = data.variants.find((item) => String(item.id) === input.getAttribute('gpo-data-variant-id'));
        if (!variant) throw new Error('Selected add-on unavailable');
        return variant.price * (isPension(input) ? quantity : 1);
      }));
      if (quantity !== Number(details.querySelector(quantities)?.value || 1) || selected.some((input) => !input.isConnected || !input.checked)) return;
      const total = formatter.format(amounts.reduce((sum, amount) => sum + amount, 0) / 100);
      details.querySelectorAll('.gpo-total-text .money').forEach((node) => {
        if (node.textContent !== total) node.textContent = total;
      });
    } catch {
      // Preserve Globo's summary if any selected add-on is unavailable.
    }
  }

  // Globo sends one meal-plan add-on by default. Set its quantity from its own
  // parent line, leaving accommodation and unrelated cart lines untouched.
  const originalFetch = window.fetch;
  window.fetch = function(resource, options) {
    let nextOptions = options;
    try {
      const url = new URL(typeof resource === 'string' || resource instanceof URL ? resource : resource.url, location.origin);
      if (url.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(url.pathname) && typeof options?.body === 'string') {
        const payload = JSON.parse(options.body);
        let changed = false;
        if (Array.isArray(payload.items)) {
          payload.items.forEach((item) => {
            if (!/pension/i.test(item.properties?._gpo_field_name || '')) return;
            const group = item.properties?._gpo_parent_product_group;
            if (!group) return;
            const parent = payload.items.find((candidate) => candidate.properties?._has_gpo && String(candidate.properties._gpo_product_group) === String(group));
            const quantity = Number(parent?.quantity);
            if (!Number.isInteger(quantity) || quantity < 1 || quantity > 2) return;
            if (item.quantity !== quantity) { item.quantity = quantity; changed = true; }
          });
        }
        if (changed) nextOptions = { ...options, body: JSON.stringify(payload) };
      }
    } catch {
      // Other requests keep their original payload.
    }
    return originalFetch.call(this, resource, nextOptions);
  };

  details.addEventListener('input', schedule);
  details.addEventListener('change', schedule);
  details.addEventListener('click', () => requestAnimationFrame(schedule));
  new MutationObserver(schedule).observe(details, { childList: true, subtree: true, characterData: true });
  schedule();
})();
